import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { KeyContents } from '../services/keycontents.service';
import { LocalStorageService } from '../services/localstorage.service';
import { ActivatedRoute } from '@angular/router';
import { Communities } from '../services/communities.service';


@Component({
  selector: 'app-contents',
  templateUrl: './contents.component.html',
})
export class ContentComponent implements OnInit, OnDestroy {

  constructor(
    private contents_service: KeyContents,
  	private _storage: LocalStorageService,
    private communities_service: Communities,
    private route: ActivatedRoute

  ) { }
  private contents_dict : any = {};
  private contentSubscription : any;

  @Input('key') key: string = "";

  ngOnInit() {
    
    this.contents_dict = this.contents_service.content_dict

    if (!Object.keys(this.contents_dict).length) {
      this.contentSubscription = this.contents_service.contents.subscribe((el) => {
        this.contents_dict = el;
      })
    }
  }

  getValue() {
    const lang = this.communities_service.getLanguage(this._storage.get('community_id'));
    const value_lang = `value_${lang}`    
    return this.contents_dict.hasOwnProperty(this.key) ? this.contents_dict[this.key][value_lang] : "";
  }
  ngOnDestroy() {
    if (this.contentSubscription) {
      this.contentSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// /mnt/disk/stratbox.dev/src/app/contents/contents.component.ts